export default "__VITE_ASSET__Duv1L46o__"